"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Feature = (function (_super) {
    __extends(Feature, _super);
    function Feature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Feature.prototype.render = function () {
        return null;
    };
    return Feature;
}(react_1.Component));
exports.default = Feature;
//# sourceMappingURL=feature.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-mapbox-gl/lib/feature.js
// module id = 344
// module chunks = 1135276415346 35783957827783 89888082226891